export const normalizeCnpj = (value: string): string => {
  return value.replace(/\D/g, "");
};

export const formatCnpj = (value: string): string => {
  const digits = normalizeCnpj(value).slice(0, 14);
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

const calculateCheckDigit = (digits: number[], weights: number[]): number => {
  const sum = digits.reduce(
    (total, digit, index) => total + digit * weights[index],
    0
  );
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

export const isValidCnpj = (value: string): boolean => {
  const normalized = normalizeCnpj(value);
  if (normalized.length !== 14 || /^(\d)\1{13}$/.test(normalized)) {
    return false;
  }

  const digits = normalized.split("").map(Number);
  const firstDigit = calculateCheckDigit(
    digits.slice(0, 12),
    [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  );
  const secondDigit = calculateCheckDigit(
    digits.slice(0, 13),
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  );

  return digits[12] === firstDigit && digits[13] === secondDigit;
};
